"use client";
import { useState } from "react";
import PropTypes from "prop-types";

import { defaultCategoryOption } from "./default-category";

import Dropdown from "components/common/dropdown";
import Button from "components/common/button";
import Input from "components/common/input";
import TextArea from "components/common/textarea";

import styles from "./styles.module.css";

const WelcomeScreen = ({ data, handleSend }) => {
  const [selectedCategory, setSelectedCategory] = useState(defaultCategoryOption);
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e) => setInputValue(e.target.value);
  const handleCategoryChange = (e) => setSelectedCategory(e);

  return (
    <div className={styles.welcomeWrap}>
      <span className={styles.title}>Hatalı İlan Bildir</span>
      <span className={styles.subInfo}>Lütfen ilanda gördüğünüz hatayı seçiniz.</span>
      <div className={styles.baseFormWrap}>
        <div className={styles.formGroup}>
          <span className={styles.label}>Hata Nedeni</span>
          <Dropdown
            placeholder="Seçiniz"
            options={data}
            onChange={handleCategoryChange}
            selectedOption={selectedCategory}
          />
        </div>
        {selectedCategory.key !== "select" && (
          <div className={styles.formGroup}>
            {selectedCategory.key === "tryed-copy" ? (
              <Input
                onChange={handleInputChange}
                value={inputValue}
                type={"number"}
                placeholder={"Lütfen diğer ilanın numarasını giriniz"}
                inputClass={styles.numberInput}
              />
            ) : (
              <TextArea
                rowNumber={6}
                value={inputValue}
                onChange={handleInputChange}
                placeholder="Detaylı bilgi giriniz"
              />
            )}
          </div>
        )}
        <div className={styles.formGroup}>
          <Button
            size="M"
            disable={selectedCategory.key === "select" || inputValue.length === 0}
            onClick={() => handleSend(selectedCategory, inputValue)}
          >
            Gönder
          </Button>
        </div>
      </div>
    </div>
  );
};

WelcomeScreen.propTypes = {
  data: PropTypes.array,
  handleSend: PropTypes.func,
};

export default WelcomeScreen;
